import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../AuthContext';


// Url base para autenticación (registro, login, gestión de usuarios)
const API_URL_AUTH = process.env.REACT_APP_API_URL_AUTH || 'http://localhost:3001/api/auth'; 


function Dashboard() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({ username: '', password: '', role: 'admin', peso: 0 });
  const [editingId, setEditingId] = useState(null);

  // Cargar usuarios al montar el componente
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      // Incluye el token en la cabecera para rutas protegidas
      const response = await axios.get(`${API_URL_AUTH}/users`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      setUsers(response.data);
    } catch (error) {
      console.error("Error cargando usuarios", error);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Manejar creación y edición en el mismo formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        // Modo Edición (no actualizamos la contraseña por simplicidad en este ejemplo)
        await axios.put(`${API_URL_AUTH}/users/${editingId}`, { 
          username: formData.username, 
          role: formData.role,
          peso: formData.peso,
          ...(formData.password && { password: formData.password }) // Solo incluir contraseña si se ha ingresado una nueva
        });
        setEditingId(null);
      } else {
        // Modo Creación
        await axios.post(`${API_URL_AUTH}/register`, {
          username: formData.username,
          password: formData.password,
          role: formData.role,
          peso: formData.peso
        });
      }
      
      setFormData({ username: '', password: '', role: 'admin', peso: 0 }); // Limpiar formulario
      fetchUsers(); // Recargar la lista
    } catch (error) {
      console.error("Error al guardar usuario", error);
      alert("Hubo un error al guardar el usuario.");
    }
  };

  const handleEditClick = (userToEdit) => {
    setEditingId(userToEdit.id);
    setFormData({ username: userToEdit.username, password: '', role: userToEdit.role, peso: userToEdit.peso });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este usuario?")) {
      try {
        await axios.delete(`${API_URL_AUTH}/users/${id}`);
        fetchUsers();
      } catch (error) {
        console.error("Error eliminando usuario", error);
      }
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', maxWidth: '800px', margin: '0 auto' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
        <h2>Panel de Administración</h2>
        <div>
          <span style={{ marginRight: '15px' }}>Hola, <strong>{user?.username}</strong></span>
          <button onClick={handleLogout} style={{ padding: '5px 10px', backgroundColor: '#d9534f', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Salir</button>
        </div>
      </header>

      {/* Formulario de Creación / Edición */}
      <div style={{ backgroundColor: '#f9f9f9', padding: '15px', marginTop: '20px', borderRadius: '5px' }}>
        <h3>{editingId ? 'Editar Usuario' : 'Crear Nuevo Usuario'}</h3>
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
          <div>
            <label style={{ display: 'block', fontSize: '12px' }}>Usuario</label>
            <input type="text" value={formData.username} onChange={(e) => setFormData({...formData, username: e.target.value})} required style={{ padding: '5px' }} />
          </div>
          

          {editingId ? (
            <div>
              <label style={{ display: 'block', fontSize: '12px' }}>Contraseña</label>
              <input type="password" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} style={{ padding: '5px' }} />
            </div>
          ) : (
            <div>
              <label style={{ display: 'block', fontSize: '12px' }}>Contraseña</label>
              <input type="password" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} required style={{ padding: '5px' }} />
            </div>
          )}
          

          <div>
            <label style={{ display: 'block', fontSize: '12px' }}>Rol</label>
            <select value={formData.role} onChange={(e) => setFormData({...formData, role: e.target.value})} style={{ padding: '5px' }}>
              <option value="admin">Admin</option>
              <option value="normal">Normal</option>
            </select>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '12px' }}>Peso</label>
            <input type="number" value={formData.peso} onChange={(e) => setFormData({...formData, peso: parseInt(e.target.value)})} required style={{ padding: '5px', width: '80px' }} />
          </div>  
          

          <button type="submit" style={{ padding: '6px 15px', backgroundColor: '#00a884', color: 'white', border: 'none', cursor: 'pointer' }}>
            {editingId ? 'Actualizar' : 'Guardar'}
          </button>
          
          {editingId && (
            <button type="button" onClick={() => { setEditingId(null); setFormData({ username: '', password: '', role: 'admin', peso: 0 }); }} style={{ padding: '6px 15px' }}>
              Cancelar
            </button>
          )}
        </form>
      </div>

      {/* Lista de Usuarios */}
      <h3 style={{ marginTop: '30px' }}>Usuarios Registrados</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
        <thead>
          <tr style={{ backgroundColor: '#eee', textAlign: 'left' }}>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>ID</th>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Usuario</th>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Rol</th>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Peso</th>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td style={{ padding: '10px', border: '1px solid #ccc' }}>{u.id}</td>
              <td style={{ padding: '10px', border: '1px solid #ccc' }}>{u.username}</td>
              <td style={{ padding: '10px', border: '1px solid #ccc' }}>{u.role}</td>
              <td style={{ padding: '10px', border: '1px solid #ccc' }}>{u.peso}</td>
              <td style={{ padding: '10px', border: '1px solid #ccc' }}>
                <button onClick={() => handleEditClick(u)} style={{ marginRight: '5px', cursor: 'pointer' }}>Editar</button>
                <button onClick={() => handleDelete(u.id)} style={{ color: 'red', cursor: 'pointer' }}>Eliminar</button>
              </td>
            </tr>
          ))}
          {users.length === 0 && (
            <tr><td colSpan="5" style={{ textAlign: 'center', padding: '10px' }}>No hay usuarios.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Dashboard;